import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {KTSVG} from '../../../../../../_metronic/helpers'
import {useIsMobile} from '../../../../../shared/responsive'
import {useDrawEndButton} from './DrawEndButtonContext'
import {drawEndButtonState} from './DrawEndButtonState'
import './DrawEndButton.style.scss'

const Buttons = () => {
  const {t} = useTranslation()
  const drawEndButton = useDrawEndButton()
  const isMobile = useIsMobile()
  const {title, buttonText} = useMemo(() => {
    return {
      title: drawEndButtonState.getTitle(),
      buttonText: drawEndButtonState.getButtonText() || t('common:actions.finish_selection'),
    }
  }, [drawEndButton, t])

  return (
    <div
      className={`displayable notice draw-end-button-container d-flex bg-light-success rounded border-success border border-dashed p-6 ${
        isMobile ? 'draw-end-button-container--mobile' : ''
      }`.trim()}
    >
      <KTSVG
        path='/media/icons/duotune/general/gen026.svg'
        className='svg-icon-3x svg-icon-success me-4 draw-end-button-container__icon'
      />
      <div className='d-flex flex-stack flex-grow-1'>
        <div className='fw-semibold draw-end-button-container__content'>
          <h4 className='text-gray-900 fw-bold'>{title}</h4>
          <p className='draw-end-button-container__copy'>
            {t('common:draw.review_before_finish')}
          </p>
          <div className='draw-end-button-container__actions'>
            <button onClick={() => drawEndButton.emit('finish')} className='btn btn-sm btn-primary me-2'>
              {buttonText}
            </button>
            <button onClick={() => drawEndButton.emit('cancel')} className='btn btn-sm btn-light'>
              {t('common:actions.cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const DrawEndButton = () => {
  const drawEndButton = useDrawEndButton()
  if (!drawEndButton.isShowing) {
    return <></>
  }

  return (
    <div className='d-flex flex-column flex-row-auto'>
      <div className='d-flex flex-column-auto mb-4'>
        <Buttons />
      </div>
    </div>
  )
}

export default DrawEndButton
